import { configureStore } from '@reduxjs/toolkit';
import courierReducer from './state/courierSlice';
import authReducer from './state/authSlice';
import cacheReducer from './state/cacheSlice';
import authorizedUsersReducer from './state/authorizedUsersSlice';
export const store = configureStore({
  reducer: {
    courier: courierReducer,
    auth: authReducer,
    cache: cacheReducer,
    authorizedUser: authorizedUsersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
